/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.consumers
 */
ApiConsumerService.$inject = [
    '$http'
];
function ApiConsumerService(
    $http
) {

    return {
        get: get,
        getFullUrl: getFullUrl,
        post: post,
        put: put,
        delete: deleteRequest,
        request: request
    };

    /**
     * Makes a request (of the given type inside requestData) to the given url of the given host with the given parameters
     * It works as a substitute for $http({'method': 'post', 'url': url, ...}) in the consumer level
     * @return {Promise}
     */
    function request(requestData, hostname) {
        var url = requestData.url;
        if (isRelativeUrl(url)) {
            url = getFullUrl(hostname, url);
            requestData.url = url;
        }

       return $http(requestData);
    }

    /**
     * Makes a get request to the given url of the given host with the given parameters
     *
     * @return {Boolean}
     */
    function get(url, config, hostname) {
        if (isRelativeUrl(url)) {
            url = getFullUrl(hostname, url);
        }
        return $http.get(url, config);
    }

    /**
     * Makes a post request to the given url of the given host with the given data
     *
     * @return {Boolean}
     */
    function post(url, data, hostname, config) {
        config = config || {};
        if (isRelativeUrl(url)) {
            url = getFullUrl(hostname, url);
        }
        return $http.post(url, data, config);
    }

    /**
     * Makes a put request to the given url of the given host with the given data
     *
     * @return {Boolean}
     */
    function put(url, data, hostname, config) {
        config = config || {};
        if (isRelativeUrl(url)) {
            url = getFullUrl(hostname, url);
        }
        return $http.put(url, data, config);
    }

    /**
     * Makes a delete request to the given url of the given host with the given data
     *
     * @return {Promise}
     */
    function deleteRequest(url, hostname, config) {
        if (isRelativeUrl(url)) {
            url = getFullUrl(hostname, url);
        }
        return $http.delete(url, config);
    }

    /**
     * Determines whether or not the given path is a relative url
     *
     * @param url
     * @returns {*|boolean}
     */
    function isRelativeUrl(url) {
        return url && !url.startsWith("http://") && !url.startsWith("https://");
    }

    /**
     * Gets the full url for the given host based on the given relative url
     * Trailing slashes are stripped from the hostname, and leading slashes are stripped from
     * urls, in order to join them with a single slash.
     *
     * @param {string} hostname
     * @param {string} url
     * @returns {string}
     */
    function getFullUrl(hostname, url) {
        return hostname.replace(/\/+$/, '') + "/" + url.replace(/^\/+/, '');
    }

}

module.exports = ApiConsumerService;